import { createTimestampTransformer } from '../common/sql';
import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { DBInstitutionSchema, InstitutionSchema } from './schemas';

export const InstitutionCodecConfig: TransformerConfig<
  typeof InstitutionSchema,
  typeof DBInstitutionSchema
> = {
  name: 'Institution',
  clientSchema: InstitutionSchema,
  dbSchema: DBInstitutionSchema,
  transformers: [
    createTimestampTransformer<typeof InstitutionSchema, typeof DBInstitutionSchema>('createdAt'),
    createTimestampTransformer<typeof InstitutionSchema, typeof DBInstitutionSchema>('updatedAt', {
      nullable: true,
    }),
  ],
};

export const encodeInstitutionToDb = createEncodeToDbFn(InstitutionCodecConfig);
export const decodeInstitutionFromDb = createDecodeFromDbFn(InstitutionCodecConfig);
